import { Icon } from '@livable/saas-react-components';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';
import useStyles from './styles';
import { v4 as uuid } from 'uuid';
export default function ArrowsList(_ref) {
  let _ref$list = _ref.list,
    list = _ref$list === void 0 ? {
      title: '',
      items: []
    } : _ref$list;
  const classes = useStyles();
  return /*#__PURE__*/React.createElement("div", {
    className: classes.smSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, list.title), /*#__PURE__*/React.createElement("ul", {
    className: classes.list,
    key: uuid()
  }, list.items.map(item => /*#__PURE__*/React.createElement("li", {
    key: item + uuid()
  }, /*#__PURE__*/React.createElement(Icon, {
    type: "arrow-right"
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "body1"
  }, item)))), list.footer && /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, list.footer));
}
ArrowsList.propTypes = {
  list: PropTypes.shape({
    title: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.string)
  })
};